import { configureStore } from "@reduxjs/toolkit";
import appStateSlice from "./features/appStateSlice";
import businessProfileStateSlice from "./features/businessProfileStateSlice";
import connectACleanerForJobStateSlice from "./features/connectACleanerForJobStateSlice";
import connectBusinessStateSlice from "./features/connectBusinessStateSlice";
import contacInfoStateSlice from "./features/contacInfoStateSlice";
import countrySlice from "./features/countryStateSlice";
import markerStateSlice from "./features/coverageSlice";
import createPlanStateSlice from "./features/createPlanStateSlice";
import formStateSlice from "./features/formStateSlice";
import notificationSlice from "./features/notificationSlice";
import planStateSlice from "./features/planStateSlice";
import promoCodesStateSlice from "./features/promoCodesStateSlice";
import signupBusinessStateSlice from "./features/signupBusinessStateSlice";
import signupEmployeeStateSlice from "./features/signupEmployeeStateSlice";
import statePickerStateSlice from "./features/stateStateSlice";
import superAdminSearchStateSlice from "./features/superAdminSearchStateSlice";
import userSelectedStateSlice from "./features/userSelectedStateSlice";
import userStateSlice from "./features/userStateSlice";
import residentialCalculatorReducer from "./features/residentialCalculatorSlice";

import calculatorSlice from "./features/calculatorSlice";
import clientStateSlice from "./features/clientStateSlice";
import jobStateSlice from "./features/jobStateSlice";
import jobSummarySlice from "./features/jobSummary";
import workTeamItemStateSlice from "./features/workTeamItem";
import jobCreateStepperSlice from "./features/jobCreateSlice";
import benefitsReducer from "../permissions/benefits/redux/benefits.slice";

import quoteCreateReducer from './features/quotes/quote-create-advanced';

import { quoteListSlice } from "./features/quotes/quoteListSlice";

export const store = configureStore({
  reducer: {
    residentialCalculator: residentialCalculatorReducer,
    appState: appStateSlice,
    formState: formStateSlice,
    countryState: countrySlice,
    statePickerState: statePickerStateSlice,
    userState: userStateSlice,
    businessProfileState: businessProfileStateSlice,
    signupEmployeeState: signupEmployeeStateSlice,
    signupBusinessState: signupBusinessStateSlice,
    userSelectedState: userSelectedStateSlice,
    connectACleanerForJobState: connectACleanerForJobStateSlice,
    connectBusinessState: connectBusinessStateSlice,
    notificationsState: notificationSlice,
    planState: planStateSlice,
    markerState: markerStateSlice,
    superAdminSearchState: superAdminSearchStateSlice,
    contactInfoState: contacInfoStateSlice,
    createPlanState: createPlanStateSlice,
    promoCodesState: promoCodesStateSlice,
    jobState: jobStateSlice,
    clientState: clientStateSlice,
    jobSummaryState: jobSummarySlice,
    workTeamItemState: workTeamItemStateSlice,
    calculatorState: calculatorSlice,


    jobCreateStepper: jobCreateStepperSlice,


    quoteCreate: quoteCreateReducer,
    quoteList: quoteListSlice.reducer,
    benefits: benefitsReducer,
  },


});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;